import styled from "styled-components";

export const ContentLibraryWrapper = styled.div`
  .content-header,
  .content-empty-state,
  .content-card,
  .content-modal {
    background: #ffffff;
    border: 1px solid #dce5df;
    border-radius: 8px;
    box-shadow: 0 18px 42px rgba(32, 51, 46, 0.06);
  }

  .content-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    margin-bottom: 1rem;
    padding: 1.5rem;
  }

  .content-header h1,
  .content-card h2,
  .content-empty-state h2,
  .content-modal h2 {
    margin: 0.25rem 0;
    color: #17342f;
    letter-spacing: 0;
    text-transform: none;
  }

  .content-header p,
  .content-empty-state p,
  .content-card p,
  .content-categories {
    color: #60716d;
  }

  .content-list {
    display: grid;
    gap: 1rem;
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  }

  .content-card {
    display: grid;
    grid-template-columns: 88px minmax(0, 1fr);
    gap: 0.85rem;
    align-items: start;
    padding: 1rem;
  }

  .content-cover {
    width: 88px;
    height: 112px;
    display: grid;
    place-items: center;
    border-radius: 8px;
    background: #edf4f1;
    color: #1d6257;
    overflow: hidden;
  }

  .content-cover img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .content-meta {
    margin: 0;
    font-weight: 700;
  }

  .content-facts {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.6rem;
    margin: 0.85rem 0;
  }

  .content-facts div {
    background: #f3f9f6;
    border-radius: 8px;
    padding: 0.65rem;
  }

  .content-facts dt {
    color: #60716d;
    font-size: 0.8rem;
    font-weight: 800;
  }

  .content-facts dd {
    margin: 0.15rem 0 0;
    color: #1e3833;
    font-weight: 900;
  }

  .content-categories {
    margin: 0;
    font-weight: 700;
  }

  .content-card-actions {
    grid-column: 1 / -1;
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 0.5rem;
  }

  .content-action-btn {
    min-height: 38px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.45rem;
    border: 1px solid #d5dfdc;
    border-radius: 8px;
    background: #ffffff;
    color: #35534d;
    cursor: pointer;
    font-weight: 800;
    padding: 0 0.75rem;
  }

  .content-action-btn.danger {
    border-color: #f0b8b8;
    color: #9f2f2f;
    background: #fff5f5;
  }

  .content-empty-state {
    max-width: 760px;
    margin-top: 1rem;
    padding: 1.5rem;
  }

  .content-error,
  .content-loading {
    margin: 0 0 1rem;
    font-weight: 800;
  }

  .content-error {
    border-radius: 8px;
    background: #fff5f5;
    color: #9f2f2f;
    padding: 0.85rem 1rem;
  }

  .content-loading {
    color: #60716d;
  }

  .content-modal-overlay {
    position: fixed;
    inset: 0;
    z-index: 8;
    display: grid;
    place-items: center;
    background: rgba(15, 25, 23, 0.46);
    padding: 1rem;
  }

  .content-modal {
    width: min(880px, 100%);
    max-height: calc(100vh - 2rem);
    overflow: auto;
    padding: 1rem;
  }

  .content-modal header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    margin-bottom: 1rem;
  }

  .content-link-btn {
    border: 0;
    background: none;
    color: #1d6257;
    cursor: pointer;
    font-weight: 900;
    padding: 0;
  }

  .content-link-btn.danger {
    color: #9f2f2f;
  }

  .content-form {
    display: grid;
    gap: 0.95rem;
  }

  .content-form-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.85rem;
  }

  .content-form-error {
    margin: 0;
    color: #9f2f2f;
    font-weight: 800;
  }

  .content-form small {
    color: #9f2f2f;
    font-weight: 800;
  }

  .content-paragraph-editor {
    display: grid;
    gap: 0.65rem;
  }

  .content-paragraph-head {
    display: flex;
    justify-content: space-between;
    gap: 1rem;
    align-items: center;
  }

  .content-paragraph-row {
    background: #f8faf8;
    border: 1px solid #e2ebe8;
    border-radius: 8px;
    display: grid;
    gap: 0.45rem;
    padding: 0.75rem;
  }

  .content-paragraph-row label {
    color: #26413b;
    font-size: 0.9rem;
    font-weight: 900;
  }

  .content-paragraph-row textarea,
  .content-form input,
  .content-form select {
    width: 100%;
    border: 1px solid #d4dfdb;
    border-radius: 8px;
    background: #ffffff;
    color: #17342f;
    font: inherit;
    font-weight: 700;
    padding: 0.7rem 0.8rem;
  }

  .content-form-actions {
    display: flex;
    justify-content: flex-end;
    gap: 0.75rem;
    margin-top: 0.5rem;
  }

  .content-preview-cover {
    max-width: 220px;
    margin-bottom: 0.75rem;
  }

  .content-preview-cover img {
    width: 100%;
    border-radius: 8px;
    border: 1px solid #dce5df;
  }

  .content-preview-meta {
    margin: 0.35rem 0;
    color: #49645e;
    font-weight: 700;
  }

  .content-preview-paragraphs {
    display: grid;
    gap: 0.5rem;
    margin: 0.9rem 0 0;
    padding-left: 1.2rem;
    color: #20332e;
  }

  @media (max-width: 760px) {
    .content-header {
      flex-direction: column;
      align-items: stretch;
    }

    .content-card,
    .content-form-grid,
    .content-card-actions {
      grid-template-columns: 1fr;
    }

    .content-cover {
      width: 100%;
      height: 180px;
    }

    .content-form-actions {
      flex-direction: column;
    }
  }
`;
